'use client';
/** @jsxImportSource @emotion/react */

import { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiMenuList, {
  type MenuListTypeMap as MuiMenuListTypeMap,
  type MenuListProps as MuiMenuListProps,
} from '@mui/material/MenuList';

type ExcludedMuiProps = keyof Pick<
  MuiMenuListProps,
  'disabledItemsFocusable' | 'disableListWrap'
>;

type CustomProps = {
  component?: ElementType;
};

type MenuListTypeMap<
  P = CustomProps,
  D extends ElementType = MuiMenuListTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiMenuListTypeMap['props'], ExcludedMuiProps> & P;
};

/**
 * @deprecated Please use `Menu` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-menu-migration--menu-migration-guide Migration guide}
 */
export type MenuListProps<
  D extends ElementType = MuiMenuListTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<MuiMenuListTypeMap<P, D>, D>;

const MenuListComponent = (
  props: MenuListProps,
  ref: Ref<HTMLUListElement>
) => {
  return <MuiMenuList {...props} ref={ref} disabledItemsFocusable={true} />;
};

MenuListComponent.displayName = 'MenuList';

/**
 * @deprecated Please use `Menu` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-menu-migration--menu-migration-guide Migration guide}
 */
export const MenuList = forwardRef(
  MenuListComponent
) as OverridableComponent<MenuListTypeMap>;
